import {redirect} from '@tanstack/react-router';
import type {LocalDate} from '@/features/dashboard/domain/local-date.value-object';
import {isLocalDate} from '@/features/dashboard/lib/local-date';

export type DashboardSearch = {
  readonly date?: LocalDate;
};

/**
 * Missing `?date` is fine. An invalid value is stripped from the URL via
 * replace-redirect, matching the previous loader.
 */
export const dashboardSearch = (search: Record<string, unknown>): DashboardSearch => {
  const raw = search.date;
  if (raw === undefined) {
    return {};
  }
  if (typeof raw === 'string' && isLocalDate(raw)) {
    return {date: raw};
  }
  throw redirect({to: '/dashboard', replace: true});
};
